// @ts-check
import { th } from "intl-tel-input/i18n";
import { PageBuilder } from "./page-builder";
import { Widget } from "./widget";
export class Home{
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
this.controller = new AbortController();
this.cleanups = [];
this.evtHandlers = [];
this.m = this.main = main;
this.state = state;
this.pb = new PageBuilder(main,this);//pageBuilder
this.widget = new Widget(main,this);
this.headerTemplate = null;
this.footerTemplate = null;
////

//used for post display
/**@type {any[]}*/ this.sidebarWidgets = [];
}//

async setDisplay(){
//when there is sidebar, and no widget to display
if(this.post$.sidebarWidgets){
this.sidebarWidgets = JSON.parse(this.post$.sidebarWidgets)||[];
if(this.sidebarWidgets.length==0){
this.post$.sidebarType='NONE';
}
}else{
  this.post$.sidebarType='NONE';
}



}//

async getTemplate() {
await this.setDisplay();
let $this=this;//cu -d
let p = this.post$;//cu -d
this.isPost = this.state.postType=='post';
this.isPage = this.state.postType=='page';
this.postTemplate = this.m.pbu.createElement('main');
this.postTemplate.innerHTML = 
`
<!--Row-->
<div class="row sp-row">
  <div class="content ${this.m.pbu.addClassIf(p.sidebarType==this.m.config.SIDEBAR_LAYOUT[0],['col-12'],['col-md-9','order-2'])}">
<!--Post title and feature image-->
<div class="cover ${this.m.pbu.showIf(p.slug!='home')} ${this.m.pbu.addClassIf(!p.featuredImageUrl,['p-4', 'p-md-5','mb-4','rounded','text-body-emphasis','bg-light-subtle'])}">
  <div class="featured-image text-center ${this.m.pbu.showIf(p.featuredImageUrl)}">
      <img src=${p.featuredImageUrl} alt="" class="featured-image img-fluid mx-auto"/>
    </div>
  <div class="px-0">
    <h1 class="display-5 fst-italic title text-center" tabindex="-1">${p.title}</h1>
  </div>
  
</div><!--#Post title and feature image-->

<div class="post-meta my-3 ${this.m.pbu.showIf((!this.isPage)&& (p.category))}">
<div class="d-flex gap-3 text-muted small">
  <!-- Category -->
  <div>
    <a href="${this.m.getHomeLink('category',p.postType,'postcategory',p.category?.title,p.category?.id)}" class="text-decoration-none badge sp-subtle text-secondary-emphasis">${p.category?.title}</a>
  </div>
<!-- Author -->
  <div>
    <i class="bi bi-person-fill me-1"></i>
    <a href="#" class="text-decoration-none badge sp-subtle text-secondary-emphasis">Mike</a>
  </div>
  <!-- Date -->
  <div>
    <i class="bi bi-calendar3 me-1"></i>
    <time datetime="2026-08-01">August 1, 2026</time>
  </div>
</div>
</div>

<div class="excerpt entry-summary clearfix my-3 ${this.m.pbu.showIf(p.showExcerpt)}">
<p class="text-muted fst-italic">${p.excerpt}</p>
</div>
  
<div class="main-content">
</div>

<div class="sp-sharer pt-0">

</div>
<!-- #social share -->

<div class="subscribe">
</div>

  </div>
<!--Right sidebar-->
  <div class="sidebar sp-sidebar position-sticky ${this.m.pbu.showIf(p.sidebarType!='NONE')}
  ${this.m.pbu.addClassIf(p.sidebarType.toUpperCase()==this.m.config.SIDEBAR_LAYOUT[1],['col-md-3','order-1'])}
  ${this.m.pbu.addClassIf(p.sidebarType.toUpperCase()==this.m.config.SIDEBAR_LAYOUT[2],['col-md-3','order-3'])}
  "> 
  </div>
  <!--#Right sidebar-->
</div>
<!--#Row-->
<section id="promptModalSection">

</section>
`;
this.mainContentDiv = $this.postTemplate.querySelector('div.main-content');
this.sidebarDiv = $this.postTemplate.querySelector('div.sp-sidebar');
this.socialShareDiv = $this.postTemplate.querySelector('div.social-share'); //??
this.spShareDiv = $this.postTemplate.querySelector('div.sp-sharer');
this.subscribeDiv = $this.postTemplate.querySelector('div.subscribe');

if(!this.state.isArchive){
await updateView();
}

return this.postTemplate;

async function updateView(){
$this.pb.isView = $this.widget.isView = true;
$this.pb.pbInput = $this.post$.mainContent;
let responseDiv = await $this.pb.initilizePageBuilder($this.state.type);//cu
$this.m.pbu.replace($this.mainContentDiv,responseDiv);
//subscription
$this.getSubscribeForm();
//add widgets to sidebar
$this.getSidebars();
    $this.cleanups.push(()=>{
      responseDiv=null;
    });

}//inner
}//func

async handleShare() {
let data = {
    title: this.post$.title,
    text: this.post$.excerpt || '',
    url: this.m.origin+this.state.url // Or a specific post link
  };

if(navigator.share){
this.m.pbu.getEventButton('Share',{icon:'share',size:'lg',cb:async ()=>{
  try {
      await navigator.share(data);
      //console.log('Shared successfully');
    } catch (err) {
      // User cancelled or error, optional fallback
      //console.log('Share cancelled or failed', err);
    }
}}).then(b=>this.m.pbu.replace(this.spShareDiv,b));
}else{
this.spShareDiv.innerHTML=
`
<div class="social-share ${this.m.pbu.showIf((!this.isPage)&& (!this.state.isArchive))}">

<div class="shareon" data-url="${data.url}" data-title="${this.m.utils.getIf(this.post$.excerpt,'')}">
  <a class="facebook"></a>
  <a class="twitter" ></a>
  <a class="whatsapp"></a>
  <a class="email"></a>
</div>

<!-- more -->
<div class="dropdown style="align-self: center;">
  <button class="btn btn-primary small dropdown-toggle m-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">More</button>
  <ul class="dropdown-menu ps-2">
  
  <div class="shareon" data-url="${data.url}" data-title="${this.m.utils.getIf(this.post$.excerpt,'')}">
    <a class="bluesky"></a>
    <a class="fediverse"></a>
    <a class="mastodon"></a>
    <a class="odnoklassniki"></a>
    <a class="pinterest"></a>
    <a class="pocket"></a>
    <a class="reddit"></a>
    <a class="teams"></a>
    <a class="telegram"></a>
    <a class="threads"></a>
    <a class="tumblr"></a>
    <a class="viber"></a>
    <a class="vkontakte"></a>
    <a class="copy-url"></a>
    <a class="print"></a>
    <!-- Does not work in every browser -->
    <a class="web-share"></a>
</div>
  </ul>
  </div>

</div>
`;
}
}//func

async getSubscribeForm(){
if(this.post$.showSubscribe && ! this.m.utils.genCookie(false,this.m.username)){
// let cta = await this.pb.getCtaComponent(
//   {
//     type:'detail',
//     v:{
//       heading:{t:'SUBSCRIBE'},
//       body:{t:this.main.config.SUBSCRIBE_TEXT},
//       button:{t:'SUBSCRIBE NOW'}
//     },
//     dClass:[]
//   });
// let p = cta.querySelector('[p]');
// this.main.pbu.replace(this.subscribeDiv,p);

//or
this.pb.getSubscribeComponent().then(sc=>{
  this.m.pbu.replace(this.subscribeDiv,sc.querySelector('[m]'));
});//then

}
}//

async getSidebars(){
if(this.sidebarWidgets.length>0){
for(let w of this.sidebarWidgets){
      //temp
      w.v.isSidebar = true;
      w.v.currentPost = this.post$;
        switch(w.m){
            case 'recentPosts':
                let recentPostsWidget = await this.widget.getRecentPostsWidget({v:w.v});
                let recentPostsHeading = this.m.pbu.createElement('h3',['text-center'],'Recent Posts');
                this.m.pbu.appendChild(this.sidebarDiv,recentPostsHeading,recentPostsWidget.querySelector('[m]') );
                break;
        }//switch
    }//for
}else{
  //show a default widget 
  //this.sidebarDiv.innerHTML = `<p class="d-flex justify-content-center align-items-center align-self-center" style="min-height: 25vh;"><img src="${this.main.media.getMediaUrl(this.postViewDto.option.logoUrl)}" class="img-thumbnail"></p>`;
}
    
}//func
async getClientHome(){
if(this.state.hasError){
await this.getErrorPage(this.state.message,this.state.responseJson,this.state.errorType);
return;
}
if(this.state.isInit){
//note: for home, url is /, must be set properly to call backend;
// the method is also called only once
let r = await this.m.fu.fetch({
link : this.m.fu.getApi((this.state.isHome && this.state.id!=-404)?'/post/page/s/home/0':this.state.url,[{n:'limit',v:-1},{n:'isInit',v:true}])
});
if(r){
this.postViewDto = r;
this.m.log(this.postViewDto,'Post.getClientHome(): this.postViewDto');
this.m.setTheme(this.postViewDto.option);
this.homeComponent = this.m.pbu.createElement('main',['home-component']);
this.m.pbu.appendChild(this.homeComponent,
`
<!--viewContainer-->
<div id = "viewContainer" class="container-fluid">
<header id="mainHeader" class="header mb-4">
</header>
<main id="mainMount" class="sp-container" style="min-height: 80vh;">
</main>
<footer id="mainFooter" class="footer sp-footer">
</footer>
</div>
<!--#viewContainer-->
`);

this.m.pbu.mount(this.homeComponent);
this.header = this.homeComponent.querySelector('header.header');
this.mainMount = this.homeComponent.querySelector('main#mainMount');
this.footer = this.homeComponent.querySelector('footer.footer');
this.headerTemplate = this.getMenuTemplate('main');
this.footerTemplate = this.getMenuTemplate('footer');
}
}

let viewTemplate;
if(this.state.isArchive){
viewTemplate = await this.getArchive()
}else{
viewTemplate = await this.getPost();
}
//NOTE: a 404 page will not return any template
if(!viewTemplate ){return;}
this.m.pbu.replace(this.mainMount,viewTemplate);
await this.setMeta();
this.addViewEvents(viewTemplate);
if(this.post$.postType=='post'){
await this.handleShare();
this.m.shareon.init();
}

}//func

async getPost(){
if(this.state.isInit){
this.post$ = this.postViewDto.posts[0];
//set id of home state
this.state.id = this.post$.id;
}else{
let r = await this.m.fu.fetch({link:this.m.fu.getApi(this.state.url,[{n:'limit',v:1}])});
this.postViewDto = r;
this.post$ = this.postViewDto.posts[0];
this.m.log(this.post$,'Post.getPost(): single post');
}
//impossible: 404 error is handle already
if(this.post$.id==-404){
  if(this.postViewDto.posts.length>1){
    //remove first element
    this.postViewDto.posts.shift();
    await this.getErrorPage("",this.postViewDto.posts);
  }else{
      await this.getErrorPage("");
  }
    //similar posts are contained that client can check 
  
  return;
}

this.postTemplate = await this.getTemplate();
return this.postTemplate;
}//func

async getArchive(){
//this is a category archive
let category;
if(this.state.isInit){
category = this.postViewDto.categories[0];
this.posts$ = this.postViewDto.posts;
}else{
    // let state = this.m.utils.clone(this.state);
    // state.link = this.m.fu.getApi(state.url,[{n:'limit',v:-1}]);
    let r = await this.m.fu.fetch({link:this.m.fu.getApi(this.state.url,[{n:'limit',v:1}])});
    if(r){
this.postViewDto = r;
category = this.postViewDto.categories[0];
this.posts$ = this.postViewDto.posts;
    }  
}

//template section
//simulate category as a post to enable use of detailTemplate
this.post$ = {
title:category.title,
excerpt:category.description,
featuredImageUrl:category.featuredImageUrl,
sidebarType:"NONE"
};
this.postTemplate = await this.getTemplate();
let recentPostsWidget = await this.widget.getRecentPostsWidget({v:{items:this.posts$,we:true,wi:true,wm:false}});
this.m.pbu.appendChild(this.postTemplate.querySelector('div.main-content'),recentPostsWidget.querySelector('[p]'));//recentPosts-parent
return this.postTemplate;
}//func

setMeta2(){
//remove old title
let currentTitle = document.querySelector("title");
if(currentTitle){currentTitle.remove();}
//remove old meta
document.head.querySelectorAll('.sp-meta').forEach(m=>m.remove());
let title = this.post$.title;
let excerpt = (this.post$.excerpt)?this.post$.excerpt:'';
let imageUrl = this.m.media.getMediaUrl(this.post$.featuredImageUrl,true,false);
let href = window.location.href;
let meta = 
`
<title class="sp-meta">${title}</title>
 <link rel="canonical" href="${href}" class="sp-meta"/>
 <meta  name="description" content="${excerpt}" class="sp-meta"/>
 <meta name="robots" content="index, follow" class="sp-meta"/>


<meta  property="og:image" content="${imageUrl}" class="sp-meta" />
<meta  property="og:image:width" content="1200" class="sp-meta"/>
<meta  property="og:image:height" content="627" class="sp-meta"/>

<meta property="og:title" content="${title}" class="sp-meta"/>
<meta property="og:description" content="${excerpt}" class="sp-meta"/>
<meta property="og:url" content="${href}" class="sp-meta"/>
<meta property="og:type" content="website" class="sp-meta"/>


<!-- Required Tags -->
<meta name="twitter:title" content="${title}" class="sp-meta"/>
<meta name="twitter:description" content="${excerpt}" class="sp-meta"/>
<meta name="twitter:image" content="${imageUrl}" class="sp-meta"/>
<meta name="twitter:card" content="summary_large_image" class="sp-meta"/> <!-- Use 'summary' for a square image -->
`;
this.m.pbu.appendChild(document.head,meta);
}//func

setMeta3(){
let p = this.post$;
let isPost = this.state.postType == 'post';
//remove old title
let currentTitle = document.querySelector("title")?.remove();
//remove old meta
document.head.querySelectorAll('.sp-meta').forEach(m=>m.remove());
let type =  (p.slug=='home')?'website':'article';
let siteName = this.m.username;
let title = this.post$.title;
let excerpt = this.post$.excerpt || '';
let imageUrl =this.post$.featuredImageUrl || '';
let href = window.location.href;
let keywords = [];
if(this.post$.keywords){
  let keywords = this.post$.keywords.split(this.m.config.SPLITTER);
  for(let k of keywords){
    keywords.push(k);
  }
}
let spHs = [...document.querySelectorAll('.sp-h.main-element span.sp-main-text')];
for(let h of spHs){
keywords.push(h.textContent.trim());
}

let meta = 
`
<title class="sp-meta">${title} | ${siteName}</title>
 <link rel="canonical" href="${href}" class="sp-meta"/>
 <meta  name="description" content="${excerpt}" class="sp-meta"/>

 <!-- new -->
 <meta name="keywords" content="${keywords.join(',')}">

 <meta name="robots" content="index, follow" class="sp-meta"/>

<meta property="og:site_name" content="@${siteName}" />
<meta property="og:title" content="${title}" class="sp-meta"/>
<meta property="og:description" content="${excerpt}" class="sp-meta"/>
<meta property="og:url" content="${href}" class="sp-meta"/>
<meta property="og:type" content="${type}" class="sp-meta"/>
`;

//category
if(isPost){
if(imageUrl){
 meta += 
`<meta  property="og:image" content="${imageUrl}" class="sp-meta" />
<meta  property="og:image:width" content="1200" class="sp-meta"/>
<meta  property="og:image:height" content="627" class="sp-meta"/>

<meta name="twitter:site" content="@${siteName}" /> 
<meta name="twitter:title" content="${title}" class="sp-meta"/>
<meta name="twitter:description" content="${excerpt}" class="sp-meta"/>
<meta name="twitter:image" content="${imageUrl}" class="sp-meta"/>
<meta name="twitter:card" content="summary_large_image" class="sp-meta"/>
`
}


  if(p.category){
    meta += `<meta property="article:section" content="${p.category.title}"/>`;
  }
  //tags
  if(p.tags){
    let tags = p.tags.split(this.m.config.SPLITTER);
    for(let tag of tags){
      meta += `<meta property="article:tag" content="${tag}" />`;
    }
  }
}
this.m.pbu.appendChild(document.head,meta);
}//func

async setMeta(){
let p = this.post$;
document.head.querySelectorAll('.sp-meta').forEach(m=>m.remove());
this.m.pbu.appendChild(document.head,this.postViewDto.meta);
let keywords = [];
if(p.keywords){
  this.m.utils.push(keywords,p.keywords.split(this.m.config.SPLITTER));
}
let spHs = [...document.querySelectorAll('.sp-h.main-element span.sp-main-text')].map(h=>h.textContent);
this.m.utils.push(keywords,spHs);
//remove old
let keywordMeta = document.head.querySelector("meta[name='keywords']");
if(keywordMeta){
  keywordMeta.remove();
}
this.m.pbu.appendChild(document.head,`<meta name="keywords" content="${keywords.join(',')}">`);
}//func

/**
 * 
 * @param {string} message 
 * @param {any} responseJson 
 */
async getErrorPage(message='',responseJson=null,errorType='404'){
//type=404;internet;generic;
let documentTitle,messageTitle,clientAction,logo,similarPosts;
switch(errorType){
  case '404':
    documentTitle = 'Not Found';
    messageTitle = 'We couldn’t find the page you were looking for.';
    clientAction = 'The link pointing here is likely to be faulty.';
    logo = 'exclamation-triangle-fill';
    if(responseJson){
      //currently only posts
      let recentPostsWidget = await this.widget.getRecentPostsWidget({v:{items:responseJson,we:true,wi:true,wm:false}});
      similarPosts = recentPostsWidget.querySelector('[p]');//parent
    }
    break;
  case 'internet':
    documentTitle = 'Problem loading page';
    messageTitle = 'You are not connected';
    clientAction = 'Please check your network connection.';
    logo = 'wifi-off';
    break;
  case 'timedout':
    documentTitle = 'Problem loading page';
    messageTitle = 'Request is taking too long';
    clientAction = 'Please check your internet connection and try again.';
    logo = 'exclamation-triangle-fill';
    break;
  case 'generic':
    this.m.utils.notify(this.m.config.ERROR_MESSAGE,{message:'Please try again later',level:2});
    return;

}
document.title = documentTitle;
this.notFoundTemplate = this.m.pbu.createElement('div',[]);
this.notFoundTemplate.innerHTML = 
`
<div class="container text-center mt-4">
<p class="text-center">
${await this.m.pbu.getSvg(logo,{width:'100',height:'100',clasz:['text-danger']})}
</p>
<h2>${messageTitle}</h2>
<h4>${clientAction}</h4>
<h4>${message}</h4>

<form class="search-post auto-complete position-relative  w-75 mx-auto ${this.m.pbu.showIf(this.mainMount && (errorType!='internet'))}" role="search">
<p>Please try searching <span class="${this.m.pbu.showIf(similarPosts)}">or check one of the posts below.</span></p>
<div class="input-group my-3">
  <input class="form-control search-post not-found" placeholder="Search">
  <span class="input-group-text search-post-button bg-primary text-white" style="cursor: pointer;">
    ${await this.m.pbu.getSvg('search')}
  </span>
</div>
<ul class="list-group mt-2 search-post-display position-absolute" style="z-index:1050;cursor:pointer;">
</ul>
</form>
</div>
`;
if(similarPosts){
this.notFoundTemplate.appendChild(similarPosts);
}

if(this.mainMount){
this.m.pbu.replace(this.mainMount,this.notFoundTemplate);
}else{
this.m.pbu.mount(this.notFoundTemplate);
}
this.addViewEvents(this.notFoundTemplate);
this.m.log(responseJson,'Main.nav404(): responseJson');
}//func
/**
 * 
 * @param {string} slug 
 * @param {string[]} clasz 
 * @returns 
 */
async getMenuTemplate(slug,clasz=[]){
    let isMain = slug=='main';
    let nav = this.m.pbu.createElement('nav',['navbar','navbar-expand-lg','navbar-light',(isMain)?'bg-white':'sp-footer','sp-navbar']);
    if(isMain){
        nav.innerHTML = 
    `
    <div class="container-fluid">
    <a class="${this.m.pbu.showIf(this.postViewDto.option.logoUrl)} ${this.m.addRouteClass('detail',false,true)} me-2" data-slug="home" href="/"><img width="60" height="60" src="${this.postViewDto.option.logoUrl}" /></a>
    <a class="${this.m.addRouteClass('detail',true,true)} sp-site-title" href="/">
    <!-- Hide on mobile, show on medium screens and up -->
  <span class="d-none d-md-inline">${this.postViewDto.option.siteName}</span>
    <!-- Show on mobile, hide on medium screens and up -->
  <span class="d-md-none">${this.m.utils.getIf(this.postViewDto.option.siteAlias,'')}</span>
  
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      </ul>
      <form class="d-flex search-post auto-complete position-relative" role="search">
        <input class="form-control me-2 search-post main-nav" type="search" placeholder="Search" aria-label="Search"/>
        <button class="btn btn-primary search-post-button" type="button">Search</button>
      <ul class="list-group search-post-display position-absolute" style="top:120%;z-index:1050;cursor:pointer;">
      </ul>
      </form>
    </div>
  </div>
    `;

    }else{
        nav.innerHTML = 
    `
   <div class="container-fluid sp-footer">
   <div class="sp-primary-footer mx-auto">
      <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
      </ul>
   </div>
  </div>
    `;
    }
    
let menuUl = nav.querySelector('.navbar-nav');
let theMenu = this.postViewDto.menus.filter(m=>m.slug==slug)[0];
if(theMenu.menuItems){
let menuItems = JSON.parse(theMenu.menuItems);
let navItem,navLink;
let url,state;
for(let m of menuItems){
    let children = m.children || [];
    let isCustom = m.postType=='custom';
    let isHome = m.title.toLowerCase()=='home';
      if(isCustom){
        url = m.link;
      }else{
        url = this.m.getHomeLink(m.component,m.postType,m.archiveType,m.title,m.postId);
      }
        if(children.length==0){
        navItem = this.m.pbu.createElement('li',['nav-item']);
        menuUl.appendChild(navItem);
        navLink = `<a ${this.m.pbu.setAttributeIf(isMain,[{n:"data-bs-toggle",v:"collapse"},{n:"data-bs-target",v:".navbar-collapse"}])} href="${url}" class="${this.m.addRouteClass('detail',true,isHome)}">${m.title}</a>`;
        this.m.pbu.appendChild(navItem,navLink);
    }else{
    //child menu
    navItem = this.m.pbu.createElement('li',['nav-item','dropdown']);
    menuUl.appendChild(navItem);
    navLink = `<a href="#"  class="dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">${m.title}</a>`;
    let subMenuUl = this.m.pbu.createElement('ul',['dropdown-menu']);
    this.m.pbu.appendChild(navItem,navLink,subMenuUl);
    for(let c of children){
        isCustom = c.postType=='custom';
        isHome = c.title.toLowerCase()=='home';
        if(isCustom){
        url = c.link;
      }else{
        url = this.m.getHomeLink(c.component,c.postType,c.archiveType,c.title,c.postId);
      }
        navItem = this.m.pbu.createElement('li',['nav-item']);
        subMenuUl.appendChild(navItem);
        navLink = `<a href="${url}" class="${this.m.addRouteClass('detail',true,isHome)}">${c.title}</a>`;
        this.m.pbu.appendChild(navItem,navLink);
    }
    }
}//for
}
this.addViewEvents(nav);
if(isMain){
this.m.pbu.replace(this.header,nav);
}else{
this.m.pbu.addClass(nav,['justify-content-center']);
this.m.pbu.replace(this.footer,nav);
// this.main.pbu.appendChild(this.footer,
//   `
//    <!-- Secondary footer -->
//       <div class="sp-secondary-footer container-fluid d-flex justify-content-end sp-footer" style="margin-top: -10px;">
//       <a href="/app/login" class="sp-route-link sp-admin text-secondary">Login</a>
//       </div><!-- #Secondary footer -->
// `
// );
//add login to footer

}
//return nav;
}//func

/**
 * 
 * @param {any} component 
 */
addViewEvents(component){
//buttons
let buttons = component.querySelectorAll('.sp-button');
for(let button of buttons){
    if(button.href){
    /**@type {URL}*/let u = new URL(button.href);
    if(u.host.includes(this.m.siteDomain) || this.m.siteDomains.includes(u.host)){
      this.m.pbu.addClass(button,['sp-route-link']);
      if(u.pathname.startsWith('/app')){
        this.m.pbu.addClass(button,['sp-admin']);
      }else{
        this.m.pbu.addClass(button,['sp-detail']);
      }
    }
    }
}
// search forms
let searchForms = component.querySelectorAll('form.search-post');//cu -d
let searchControl,searchButton;
for(let sf of searchForms){
searchControl = sf.querySelector('input.search-post');
searchButton = sf.querySelector('.search-post-button');//button or span
this.m.pbu.listen(searchControl,'input',async ()=>{
this.search(searchControl);
},this);

this.m.pbu.listen(searchButton,'click',()=>{
    if(searchControl.value){
        this.search(searchControl);
    }
    
},this);
}
//contact forms
// let forms = this.main.pbu.queryAll('.sp-contact-form')||[];//cu
// for(let form of forms){
//     this.processForms(form);
// }
//finally
this.m.addRouteEvents(component);
}//

/**
 * 
 * @param {HTMLInputElement} input 
 */    
async search(input){
try{

if(input.value.length<2){return;}  
if(!this.m.vu.sanitize([input])){return;}
let regex = new RegExp(`${input.value}`, "i");
let posts = await this.m.fu.fetch({link:this.m.fu.getApi('/home/posts',[{n:'limit',v:-1}])});
posts = posts.filter(p=>regex.test(p.title));
this.m.autoComplete(input,true,posts,'post');


// if(input.classList.contains('main-nav')){
// //NOTE: nav menu search position is processed dynamically
// let rect = input.getBoundingClientRect();
// let form = input.closest('form.auto-complete');
// let searchDisplay = form.querySelector('ul.search-post-display');
// searchDisplay.style.left =  "0px";
// searchDisplay.style.top =  rect.bottom  + "px";
// }

}catch(error){
this.m.utils.notify(this.m.config.ERROR_MESSAGE,{level:2});
this.m.log(error,'FetchUtils.fetch(): fetch error');
}

}//func   
}//class